import { sdk as squareSdk } from '@squareup/sq-addons-web-sdk'
import { useEffect } from 'react'

const callbacks = {}

const SettingsSlot = () => {
  useEffect(() => {
    const initializeSdk = async () => {
      await squareSdk.initialize(callbacks)
    }

    initializeSdk()
  }, [])

  return <></>
}

export default SettingsSlot
